exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col1[data-v-081d642b] {\n  width: 220px;\n}\n.col2[data-v-081d642b] {\n  width: 140px;\n  text-align: right;\n}\n.col3[data-v-081d642b] {\n  width: 300px;\n  padding-left: 10px;\n}\n", ""]);

// exports
